



























import { Input, InputLabel, AltInputLabel, InputError } from '../../atoms/Input'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { formatFAIcon } from '../../../utils/formatter'
import { ACTIVATED } from '../../../utils/errors'

@Component({
  components: {
    Input,
    InputLabel,
    AltInputLabel,
    InputError
  }
})
export default class InputGroup extends Vue {
  @Prop({ required: true, type: String }) readonly value!: string
  @Prop({ type: String, default: '' }) readonly label?: string
  @Prop({ type: String, default: '' }) readonly altLabel?: string
  @Prop({ type: String, default: '' }) readonly inputFor?: string
  @Prop({ type: String, default: '' }) readonly name?: string
  @Prop({ type: String, default: '' }) readonly id?: string
  @Prop({ type: String, default: 'text' }) readonly type?: string
  @Prop({ type: String, default: '' }) readonly error?: string
  @Prop({ type: Boolean, default: false }) readonly hiddenField?: boolean
  @Prop({ type: Boolean, default: false }) readonly disabled?: boolean
  @Prop({ type: String, default: '' }) readonly containerCustomStyle?: string
  @Prop({ type: Number }) readonly maxLength?: number

  get showActivatedLabel(): boolean {
    return this.altLabel === ACTIVATED
  }
  get faIcon(): string {
    return formatFAIcon('check-circle')
  }
}
